import React, { useState, useEffect, useRef, Fragment } from "react";
import { Container, Row, Col, Card, Image, Spinner } from "react-bootstrap";
import { Link } from "react-router-dom"; // Import useLocation
import { Mail } from "react-feather";

import apiService from "../../services/apiService";

import logo from "../../logo.png";

const EmailVerification = () => {
  const didFetch = useRef(false);

  const [isVerified, setIsVerified] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (didFetch.current) return; // Prevent second call
    didFetch.current = true;

    // Get the query string from the current URL
    const queryParams = new URLSearchParams(window.location.search);
    const token = queryParams.get("token");
   
    const verifyEmail = async () => {
      try {
        setIsLoading(true);
        const response = await apiService.get(`/email/verify?token=${token}`);
        console.log(response);
        setIsVerified(true);
      } catch (error) {
      } finally {
        setIsLoading(false);
      }
    };

    if (token) verifyEmail();
    else {
      setIsLoading(false);
    }
  }, []);

  return (
    <Container className="min-vh-100 d-flex align-items-center justify-content-center flex-column">
      <Row>
        <Col xs={12} className="text-center mb-4">
          <Image
            src={logo}
            alt={`${process.env.REACT_APP_PORTAL}`}
            fluid
            width="225px"
          />
        </Col>
        <Col xs={11} md={9} lg={7} xl={6} xxl={6} className="m-auto">
          <Card className="p-4 shadow border-0">
            <Card.Body className="text-center">
              {isVerified && (
                <Fragment>
                  <Mail size={40} className="text-secondary mb-3" />
                  <h1 className="text-center mb-3 fs-5">Email Verified!</h1>
                  <p className="text-center mb-4 text-light-emphasis fw-light">
                    Thank you for signing up. Your account has been successfully
                    verified.
                  </p>
                  <hr className="mt-5 mb-4" />
                  <div className="text-center text-light-emphasis fw-light fs-medium">
                    <Link
                      title="Login"
                      to="/login"
                      className="text-decoration-none link-primary fw-semibold "
                    >
                      Click here
                    </Link>{" "}
                    to login
                  </div>
                </Fragment>
              )}
              {!isVerified && !isLoading && (
                <Fragment>
                  <Mail size={40} className="text-secondary mb-3" />
                  <h1 className="text-center mb-3 fs-5">
                    Verification Failed!
                  </h1>
                  <p className="text-center mb-4 text-light-emphasis fw-light">
                    Something went wrong. Verification process couldn't be
                    completed.
                  </p>
                  <hr />
                  <small className="text-dark-emphasis fw-light">
                    To verify your account, contact our support team at{" "}
                    <Link
                      title="Support"
                      to={`mailto:${process.env.REACT_APP_SUPPORT_EMAIL}`}
                      className="text-decoration-none link-secondary fw-bold"
                    >
                      {process.env.REACT_APP_SUPPORT_EMAIL}
                    </Link>
                    .
                  </small>
                </Fragment>
              )}
              {isLoading && (
                <div className="mt-4">
                  <Spinner animation="border" role="status" variant="primary">
                    <span className="visually-hidden">Loading...</span>
                  </Spinner>
                  <p className="mb-0 mt-3 text-dark-emphasis fw-light">
                    Please wait while your account is being verified...
                  </p>
                </div>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default EmailVerification;
